import { render } from "./FrequentlyReports.vue?vue&type=template&id=3f78a574&scoped=true"
import script from "./FrequentlyReports.vue?vue&type=script&lang=js"
export * from "./FrequentlyReports.vue?vue&type=script&lang=js"

import "./FrequentlyReports.vue?vue&type=style&index=0&id=3f78a574&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f78a574"]])

export default __exports__